import { Module }                            from 'vuex';
import { ConversationSessionDefaultState,
         IConversationSessionState }         from './WidgetState';
import { ConversationSessionEntityActions }  from './WidgetActions';
import { ConversationSessionGetters }        from './WidgetGetters';
import { ConversationSessionMutations }      from './WidgetMutations';

export const conversationSession: Module<IConversationSessionState, IConversationSessionState> = {
  namespaced: true,
  actions:    {
    ...ConversationSessionEntityActions,
  },
  getters:    {
    ...ConversationSessionGetters,
  },
  state:      {
    ...ConversationSessionDefaultState(),
  },
  mutations:  {
    ...ConversationSessionMutations,
  },
};